/**
 * Typeguard which filters out non-nulls
 */
export const isNull = (x) => x === null;
/**
 * Typeguard which filters out null
 */
export const isNotNull = (x) => x !== null;
/**
 * Typeguard which filters out undefined
 */
export const isDefined = (value) => value !== undefined;
/**
 * Typeguard which filters out undefined and null
 */
export const hasValue = (value) => value !== undefined && value !== null && value !== '';
/**
 * Typeguard which checks if array is empty
 */
export const isEmptyArray = (value) => value.length === 0;
/**
 * Filter out whitespaced or nullish strings
 */
export const isNonWhitespaceString = (value) => typeof value === 'string' && value.trim().length > 0;
/**
 * Check if variable is a string
 */
export const isString = (value) => typeof value === 'string';
/**
 * Check if variable is a number
 */
export const isNumber = (value) => {
    return (hasValue(value) &&
        (typeof value === 'string' || typeof value === 'number') &&
        !isNaN(Number(value)));
};
/**
 * Check if object is empty
 */
export const isObjectEmpty = (value) => Object.keys(value).length === 0;
/**
 * Check if variable is an object
 */
export const isObject = (value) => typeof value === 'object';
//# sourceMappingURL=typeguards.utils.js.map